export const getSelectedWhatsAppId = (search = "") => {
  const params = new URLSearchParams(search);
  return params.get("whatsappId") || "";
};

export const buildTicketsPath = ({ ticketId, whatsappId, search = "" }) => {
  const params = new URLSearchParams(search);

  if (whatsappId === null || whatsappId === "") {
    params.delete("whatsappId");
  } else if (whatsappId !== undefined) {
    params.set("whatsappId", String(whatsappId));
  }

  const path = ticketId ? `/tickets/${ticketId}` : "/tickets";
  const query = params.toString();

  return query ? `${path}?${query}` : path;
};
